/** @format **/

function cleanUp(path) {
  Object.entries(path).forEach(([key, value]) => {
    if (value && typeof value === "object") {
      cleanUp(value);
    }
    if (value === (null || undefined)) {
      delete path[key];
    }
  });

  return path;
}

export function generateScreen(
  screenConfigs,
  { i18n, screens, screenTypePostfix = "" }
) {
  return screens.map((screen) => {
    const defaultConfig = screenConfigs(i18n)[screen.name] || {};

    const path = {
      type: screenTypePostfix
        ? `${defaultConfig.type}.${screenTypePostfix}`
        : defaultConfig.type,
      ...((defaultConfig.flowConfirmation || screen.flowConfirmation) && {
        flowConfirmation: {
          ...defaultConfig.flowConfirmation,
          ...screen.flowConfirmation,
        },
      }),
      ...((defaultConfig.params || screen.params) && {
        params: {
          ...defaultConfig.params,
          ...screen.params,
          conditions: [
            ...(defaultConfig.params?.conditions || []),
            ...(screen.params?.conditions || []),
          ],
        },
      }),
    };

    return cleanUp(path);
  });
}

export const generateSkipCondition = (propertyName) => ({
  property: propertyName,
  isSet: false,
});



// WEBPACK FOOTER //
// ./src/partners/config/screens/generator.js